export enum ProductStatus {
    ACTIVE = 'ACTIVE',
    DISCONTINUED = 'DISCONTINUED',
    ON_HOLD = 'ON_HOLD',
}

export const ProductStatusLabels: Record<ProductStatus, string> = {
    [ProductStatus.ACTIVE]: 'Active',
    [ProductStatus.DISCONTINUED]: 'Discontinued',
    [ProductStatus.ON_HOLD]: 'On Hold',
};

export function getProductStatusLabel(status: ProductStatus | string | null | undefined): string {
    if (!status) return ProductStatusLabels[ProductStatus.ACTIVE];
    return ProductStatusLabels[status as ProductStatus] ?? status;
}

export type ProductStatusSeverity = 'success' | 'info' | 'warn' | 'danger';

const ProductStatusSeverityMap: Record<ProductStatus, ProductStatusSeverity> = {
    [ProductStatus.ACTIVE]: 'success',
    [ProductStatus.DISCONTINUED]: 'danger',
    [ProductStatus.ON_HOLD]: 'warn',
};

export function getProductStatusSeverity(status: ProductStatus | string | null | undefined): ProductStatusSeverity {
    if (!status) return 'success';
    return ProductStatusSeverityMap[status as ProductStatus] ?? 'info';
}
